import React, { useState } from 'react';
import { useUser } from '../utils/UserContext';
import TabBar from '../components/shared/TabBar';
import InnerTabsm from '../components/shared/InnerTabsm';
import { CalendarIcon2 } from '../components/shared/Icons';
import CalendarIframe from './CalendarIframe';

const TABS = [
  {
    id: 'calendarleave',
    label: 'Leave',
    
  },
  {
    id: 'calendarclient',
    label: 'Client',
    
  },
];

const LEAVE_INNER = [
  { id: 'leavecalendar', label: 'Leave', icon: <CalendarIcon2 />,
    component: () => <CalendarIframe url="https://airtable.com/embed/appinITusLeUE9ifR/shrj7OGp34El7m0Rq?backgroundColor=dark" /> },
  { id: 'replacementcalendar', label: 'Replacement', icon: <CalendarIcon2 />,
    component: () => <CalendarIframe url="https://airtable.com/embed/appinITusLeUE9ifR/shr1pJBWYexwWbpji?backgroundColor=dark" /> },
  { id: 'extraworkcalendar', label: 'Extra Work', icon: <CalendarIcon2 />,
    component: () => <CalendarIframe url="https://airtable.com/embed/appj4V5zaWcFiR7NM/shrBpJJGWJBe805v7?backgroundColor=dark" /> },
];

const WORKFLOW_INNER = [
  { id: 'periodicalcalendar', label: 'Periodical', icon: <CalendarIcon2 />,
    component: () => <CalendarIframe url="https://airtable.com/embed/appciHwOR34Suu6Qm/shrlwzfqjvHXWaVcL?backgroundColor=dark" /> },
  { id: 'southyarracalendar', label: 'South Yarra', icon: <CalendarIcon2 />,
    component: () => <CalendarIframe url="https://airtable.com/embed/apprjJS4aecux6Cf1/shrv09STVpiDCFpQY?backgroundColor=dark" /> },
  { id: 'ticketcalendar', label: 'Ticket', icon: <CalendarIcon2 />,
    component: () => <CalendarIframe url="https://airtable.com/embed/appUbsPnUAWdyKLEC/shrwa9EFvZh0NgL20?backgroundColor=dark" /> },
];

const FilterSuperCalendarPagem = () => {
  const [activeTab, setActiveTab] = useState('calendarleave');
  const { homeAccent } = useUser();

  

  return (
    <div className="fr-tab-page">
      <TabBar
        tabs={TABS}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        homeRoute="/profile"
        homeColor={homeAccent}
      />
      <div className="fr-tab-content">
        {activeTab === 'calendarleave' && <InnerTabsm tabs={LEAVE_INNER} defaultId="leavecalendar"/>}
        {activeTab === 'calendarclient' && <InnerTabsm tabs={WORKFLOW_INNER} />}
      </div>
    </div>
  );
};

export default FilterSuperCalendarPagem;